/**
 * Central Standard Time (CST) date/time utilities.
 * All dates across the NTX CRM display in America/Chicago timezone.
 */
const TZ = 'America/Chicago';

/** Full date: "Sep 7, 2026" */
export function fmtDate(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-US', { timeZone: TZ, month: 'short', day: 'numeric', year: 'numeric' });
}

/** Short date: "Sep 7" */
export function fmtShortDate(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-US', { timeZone: TZ, month: 'short', day: 'numeric' });
}

/** Date + time: "Sep 7, 12:30 PM" */
export function fmtDateTime(d) {
  if (!d) return '';
  return new Date(d).toLocaleString('en-US', { timeZone: TZ, month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}

/** Full date + time: "Sep 7, 2026 12:30 PM CST" */
export function fmtFull(d) {
  if (!d) return '—';
  return new Date(d).toLocaleString('en-US', { timeZone: TZ, month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
}

/** Time only: "12:30 PM" */
export function fmtTime(d) {
  if (!d) return '';
  return new Date(d).toLocaleTimeString('en-US', { timeZone: TZ, hour: 'numeric', minute: '2-digit' });
}

/** Relative time: "2m ago", "3h ago", "Yesterday", "Sep 5" */
export function timeAgo(dateStr) {
  if (!dateStr) return '';
  const now = new Date();
  const d = new Date(dateStr);
  const diff = Math.floor((now - d) / 1000);
  if (diff < 60) return 'Just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 172800) return 'Yesterday';
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return fmtDate(dateStr);
}

/** Format date for input[type="date"] value in CST: "2026-09-07" */
export function toDateInputCST(d) {
  if (!d) return '';
  const parts = new Date(d).toLocaleDateString('en-CA', { timeZone: TZ }); // en-CA gives YYYY-MM-DD
  return parts;
}

/** Get "today" in CST as ISO date string */
export function todayCST() {
  return new Date().toLocaleDateString('en-CA', { timeZone: TZ });
}

/** Days from today (in CST) to a target date */
export function daysFromNowCST(targetDate) {
  if (!targetDate) return null;
  const today = todayCST();
  const diff = Math.ceil((new Date(targetDate) - new Date(today)) / 86400000);
  return diff;
}

/** Format for date display on invoices/formal docs: "September 7, 2026" */
export function fmtLongDate(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-US', { timeZone: TZ, month: 'long', day: 'numeric', year: 'numeric' });
}
